import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query';
import { createQueryClient } from './lib/queryClient';
import { routeTree } from './routeTree.gen';

/** User subset van root `beforeLoad` (server), genoeg voor o.a. accountpagina. */
export interface RootContextUser {
  email: string;
  user_metadata?: { display_name?: string } & Record<string, unknown>;
}

export interface RouterContext {
  queryClient: QueryClient;
  user: RootContextUser | null;
}

export function getRouter() {
  const queryClient = createQueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient, user: null },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
  });

  // Dehydreert de server-cache naar de client en wrapt de app in QueryClientProvider
  setupRouterSsrQueryIntegration({ router, queryClient });

  return router;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
